import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Form} from 'antd';

import { Select, Input } from 'antd';
import { actions, asyncUpdate, asyncAdd, asyncGet } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;
const { TextArea } = Input;

class Edit extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.changeCurrentSelectId();
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                if (this.props.item._id === undefined) {
                    await this.props.asyncAdd(formatFormData(values));
                } else {
                    await this.props.asyncUpdate(formatFormData(values));
                }
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.changeCurrentSelectId();
                this.props.asyncGet();
            } else {
                console.log(err);
            }
        });
    };

    render() {
        const { isModalShow, isLoading, item } = this.props;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>
            
                    <Col span={10}>
                        <FormItem {...formItemLayout} label="">
                            {getFieldDecorator('_id', {
                                initialValue: item._id,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写"  type="hidden" style={{ width: '100%' }} disabled />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={10}>
                        <FormItem {...formItemLayout} label="">
                            {getFieldDecorator('advertId', {
                                initialValue: item.advertId || '0',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写"  type="hidden" style={{ width: '100%' }} disabled />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="时间">
                            {getFieldDecorator('time', {
                                initialValue: item.time || '0',
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写"   style={{ width: '100%' }} disabled />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="app">
                            {getFieldDecorator('app', {
                                initialValue: item.app || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled/>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="广告平台">
                            {getFieldDecorator('adPlatform', {
                                initialValue: item.adPlatform || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="接入方式">
                            {getFieldDecorator('joinWay', {
                                initialValue: item.joinWay || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="手机系统">
                            {getFieldDecorator('phoneSystem', {
                                initialValue: item.phoneSystem || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="广告位">
                            {getFieldDecorator('adPosition', {
                                initialValue: item.adPosition || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled />,  
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="cpm单价">
                            {getFieldDecorator('cpmPrice', {
                                initialValue: item.cpmPrice || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,  
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="官方曝光">
                            {getFieldDecorator('officialEv', {
                                initialValue: item.officialEv || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,  
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="官方点击">
                            {getFieldDecorator('officialClick', {
                                initialValue: item.officialClick || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,  
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="日总收入">
                            {getFieldDecorator('intoDayTotalNum', {
                                initialValue: item.intoDayTotalNum || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,  
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="投入手机数量">
                            {getFieldDecorator('intoPhoneNum', {
                                initialValue: item.intoPhoneNum || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,  
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="备注">
                            {getFieldDecorator('remark', {
                                initialValue: item.remark || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,  
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );

        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.advertPositionData.list.reduce((a, b) => (b._id === state.advertPositionData.currentSelectId ? b : a), {}),
    isModalShow: state.advertPositionData.uiStatus.isUpdateShow,
    isLoading: state.advertPositionData.uiStatus.isLoading,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShow: false })),
    asyncUpdate: contents => dispatch(asyncUpdate(contents)),
    asyncAdd: contents => dispatch(asyncAdd(contents)),
    asyncGet: () => dispatch(asyncGet()),
    changeCurrentSelectId: () => dispatch(actions.changeCurrentSelectId('')),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/advertPositionData/edit.js